import API from 'services/API';

export default function getCalendarEvents(year) {
  return API.request({
    method: 'GET',
    url: '/calendarEvent',
    params: { year },
  });
}
